import React from 'react';
import { withStyles } from '@material-ui/styles';
import MuiGrid from '@material-ui/core/Grid';
import { createMuiTheme } from '@material-ui/core/styles';
import {
  Info,
  ThumbUp,
  Error,
  MoodBad,
  DeleteForever,
  MoneyOff,
} from '@material-ui/icons';
import { Checkbox, Chip } from '@material-ui/core';

export const Grid = withStyles((theme) => ({
  root: (props) => {
    return props.color
      ? {
          backgroundColor:
            theme.palette[props.color || 'primary'][theme.palette.type || 'light'],
        }
      : {};
  },
}))(MuiGrid);

export const CheckBoxIcon = withStyles((theme) => ({
  root: (props) => {
    return {
      color: theme.palette[props.color || 'primary'][theme.palette.type || 'light'],
    };
  },
}))(({ color, ...props }) => <Checkbox {...props} />);

export const InfoIcon = withStyles((theme) => ({
  root: (props) => {
    return {
      color: theme.palette[props.color || 'primary'][theme.palette.type || 'light'],
    };
  },
}))(({ color, ...props }) => <Info {...props} />);

export const ThumbUpIcon = withStyles((theme) => ({
  root: (props) => {
    return {
      color: theme.palette[props.color || 'primary'][theme.palette.type || 'light'],
    };
  },
}))(({ color, ...props }) => <ThumbUp {...props} />);

export const ErrorIcon = withStyles((theme) => ({
  root: (props) => {
    return {
      color: theme.palette[props.color || 'primary'][theme.palette.type || 'light'],
    };
  },
}))(({ color, ...props }) => <Error {...props} />);

export const MoodBadIcon = withStyles((theme) => ({
  root: (props) => {
    return {
      color: theme.palette[props.color || 'primary'][theme.palette.type || 'main'],
    };
  },
}))(({ color, ...props }) => <MoodBad {...props} />);

export const DeleteIcon = withStyles((theme) => ({
  root: (props) => {
    return {
      backgroundColor: 'white',
      borderRadius: '10px',
      color: theme.palette[props.color || 'primary'][theme.palette.type || 'main'],
    };
  },
}))(({ color, ...props }) => <DeleteForever {...props} />);

export const MoneyOffIcon = withStyles((theme) => ({
  root: (props) => {
    return {
      color: theme.palette[props.color || 'primary'][theme.palette.type || 'main'],
    };
  },
}))(({ color, ...props }) => <MoneyOff {...props} />);

export const ChipWrapped = withStyles((theme) => ({
  root: (props) => {
    return {
      color: theme.palette[props.color || 'primary'].contrastText,
      backgroundColor:
        theme.palette[props.color || 'primary'][theme.palette.type || 'main'],
    };
  },
}))(({ color, ...props }) => <Chip {...props} />);

const theme = createMuiTheme();
